var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "x-container",
    { attrs: { "app-width": "", fluid: "", "grid-list-lg": "" } },
    [
      _c(
        "modal",
        {
          ref: "unauthorisedModalView",
          attrs: { "action-text": "Ok", title: "Unauthorised" },
        },
        [
          _c(
            "x-layout",
            { attrs: { "mt-4": "" } },
            [
              _c("x-flex", [
                _c("p", [
                  _vm._v(
                    "You do not have the required permissions to perform this action."
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }